import React, { useState } from 'react';
import { Icon, Input, Button as ButtonS } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import { deleteEvent, getEvent } from "../../api/eventApi";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoadingTop from "../../component/LoadingTop";

const Event = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [status, setStatus] = useState(2);

  const handleAction = (d, type) => {
    if (type === "edit") return history.push(`/event/edit?id=${d.id}`)
    else return openModal(d.id);
  }

  const openModal = (id) => {
    setModal(true);
    setEventId(id);
  }

  const toggle = () => setModal(!modal);

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      await deleteEvent(eventId);
      window.history.back();
      toggle()
      setEventId(null);
      await loadData();
    } catch (err) { }
    setLoadingDelete(false);
  }

  const loadData = async (s) => {
    try {
      const res = await getEvent();
      setData(res.data.content);
    } catch (err) { }
  }

  React.useEffect(() => {
    loadData();
  }, []);

  const parsedDateInd = (cell, row) => {
    return cell ? moment.utc(cell).locale("id").tz("Asia/Jakarta").format("DD MMMM YYYY H:m") : "-";
  };

  const formatterAction = (cell, row) => {
    return (
      <>
        <Icon name="pencil" className="cursor-pointer" onClick={() => handleAction(row, "edit")} />
        <Icon name="trash alternate outline" color="red" className="cursor-pointer" onClick={() => handleAction(row, "delete")} />
      </>
    )
  }

  const columns = [{
    dataField: "name",
    text: "Nama",
  },
  {
    dataField: "createdAt",
    text: "Tanggal",
    formatter: parsedDateInd
  },
  {
    dataField: "createdBy.email",
    text: "Oleh",
  },
  {
    text: "",
    formatter: formatterAction,
    headerStyle: () => ({ width: "10%" }),
  }
  ];

  const indication = () => {
    return (
      <p className="text-center">
        {data ? "Belum ada data" : "Loading data ..."}
      </p>
    );
  };

  return (
    <>
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4 px-5">
          <div className="row">
            <div className="col-md-4 d-flex align-items-center mb-md-0 mb-3">
              <h3>Event</h3>
            </div>
            <div className="col">
              <div className=" btn-group col-sm-6 d-flex justify-content-center align-items-center">
                <Button className="btn mr-5" color='outline-info' onClick={() => window.open('https://simolek.jabarprov.go.id/bumd/', '_blank')}>Berita & Event BUMD</Button>
              </div>
            </div>
            <div className="row">
              <div className=" btn-group col-sm-12 d-flex justify-content-end align-items-end ">
                <ButtonS color='blue' onClick={() => history.push("/event/add")}>+ &nbsp; Tambah</ButtonS>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container shadow-sm py-3 border-0">
              <div className="row">
                <div className="col-md-6 d-flex align-items-center">
                  <Input
                    icon
                    iconPosition="left"
                    className="w-100 my-3"
                    placeholder="Cari Event"
                  >
                    <input />
                    <Icon name="search" />
                  </Input>
                </div>
              </div>
              <BootstrapTable
                headerClasses="table--header"
                keyField="id"
                data={data || []}
                columns={columns}
                // bordered={false}
                noDataIndication={indication}
              // hover={props.hover}
              // rowEvents={props.rowOnClick && rowEvents}
              // ddefaultSortDirection="asc"
              // rowStyle={ rowStyle }
              />
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Konfirmas</ModalHeader>
        <ModalBody>
          Apakah anda yakin akan menghapus data?
        </ModalBody>
        <ModalFooter>
          <ButtonS color='light'>Tidak</ButtonS>
          <ButtonS color='red' onClick={handleDelete} loading={loadingDelete}>Ya</ButtonS>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default Event
